import React, { useRef, useState } from 'react';
import useImpressionNCP from '../../../hooks/emarsys/new-car-purchase/useImpressionNCP';
import useImpressionNCL from '../../../hooks/emarsys/new-car-list/useImpressionNCL';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';
import useImpressionCouponService from '../../../hooks/emarsys/coupon-service/useImpressionCouponService';
import useImpressionCouponServiceList from '../../../hooks/emarsys/coupon-service/useImpressionCouponServiceList';
import eventClickCouponService from '../../../helpers/emarsys/coupon-service/eventClickCouponService';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import useImpressionPackageService from '../../../hooks/emarsys/package-service/useImpressionPackageService';
import useImpressionPackageServiceList from '../../../hooks/emarsys/package-service/useImpressionPackageServiceList';
import useImpressionAccessories from '../../../hooks/emarsys/accessories/useImpressionAccessories';
import eventClickAccessories from '../../../helpers/emarsys/accessories/eventClickAccessories';
import useImpressionProductKnowledgeList from '../../../hooks/emarsys/product-knowledge/useImpressionProductKnowledgeList';
import eventClickProductKnowledgeList from '../../../helpers/emarsys/product-knowledge/eventClickProductKnowledgeList';
import useImpressionNewsList from '../../../hooks/emarsys/news/useImpressionNewsList';
import eventClickNewsList from '../../../helpers/emarsys/news/eventClickNewsList';
import useImpressionDetailTestDrive from '../../../hooks/emarsys/test-drive/useImpressionDetailTestDrive';
import eventClickPackageService from '../../../helpers/emarsys/package-service/eventClickPackageService';
import { FEATURE } from '../../../constants/emarsys/feature';
import eventClickListingPromo from '../../../helpers/emarsys/promo/eventClickListingPromo';
import { PAGE_NAME_PROMO } from '../../../constants/emarsys/promo';
import useImpressionTestDriveList from '../../../hooks/emarsys/test-drive/useImpressionTestDriveList';
import eventClickTestDriveList from '../../../helpers/emarsys/test-drive/eventClickTestDriveList';
import { BUTTON_NAME_TEST_DRIVE_LIST } from '../../../constants/emarsys/test-drive';

interface InfoSectionProps {
  info: {
    title: string;
    desc: string;
  };
  idName?: string;
  sectionClassName?: string;
  headingClassName?: string;
  contentClassName?: string;
  enableSharing?: boolean;
  labelClassname?: string;
  containerClassName?: string;
  paddingClassname?: string;
  impressionData?: {
    title?: string;
    carModel?: string;
    pageTitle: string;
    menu?: string;
    breadcrumbItems?: IBreadcrumbs[];
    sku?: string;
    skuPrice?: string;
    carModels?: string[];
    category?: string;
    page_number?: number;
    menu_cat_lvl2?: string;
  };
  feature?: string;
  onClickTogleShowMore?: () => void;
  titleId?: string;
  descriptionId?: string;
}

const InfoSection = ({
  info,
  idName = 'post-1',
  sectionClassName = '',
  containerClassName = '',
  headingClassName = '',
  contentClassName = '',
  enableSharing = false,
  labelClassname = 'lg:text-base font-semibold',
  paddingClassname = '5',
  impressionData = {
    title: '',
    carModel: '',
    pageTitle: '',
    menu: '',
    breadcrumbItems: [],
    sku: '',
    skuPrice: '',
    carModels: [],
    category: '',
    page_number: 1,
  },
  feature = '',
  onClickTogleShowMore,
  titleId = '',
  descriptionId = '',
}: InfoSectionProps) => {
  const impressionRef = useRef(null);
  const dispatch = useDispatch();
  const [showMore, setShowMore] = useState(false);

  const { selectedCar, selectedPackage } = useSelector((state: any) => state.servicePackage) || {
    selectedCar: null,
    selectedPackage: null,
  };
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };

  const formattedDescription = info?.desc?.replace(/\n/g, '<br />');

  const toggleShowMore = () => {
    if (feature === 'COUPON_SERVICE_DETAIL' && !showMore) {
      eventClickCouponService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        'detail kupon servis',
        'lihat selengkapnya'
      );
    } else if (feature === 'ACCESSORIES_DESCRIPTION' && !showMore) {
      eventClickAccessories(
        dispatch,
        impressionData.sku,
        impressionData.skuPrice,
        impressionData.pageTitle,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        'product description',
        'lihat selengkapnya',
        impressionData.carModels
      );
    } else if (feature === 'ACCESSORIES_INFO' && !showMore) {
      eventClickAccessories(
        dispatch,
        impressionData.sku,
        impressionData.skuPrice,
        impressionData.pageTitle,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        info?.title || 'aksesoris & spareparts toyota',
        'lihat selengkapnya',
        impressionData.carModels
      );
    } else if (feature === 'LISTING_PRODUCT_KNOWLEDGE' && !showMore) {
      eventClickProductKnowledgeList(
        impressionData.pageTitle,
        impressionData.category,
        impressionData.page_number,
        'informasi review',
        'lihat selengkapnya'
      );
    } else if (feature === 'NEWS_LIST' && !showMore) {
      eventClickNewsList(
        impressionData.pageTitle,
        impressionData.category,
        impressionData.page_number,
        'informasi berita toyota',
        'lihat selengkapnya'
      );
    } else if (feature === 'TEST_DRIVE_DETAIL' && onClickTogleShowMore) {
      onClickTogleShowMore();
    } else if (feature === 'COUPON_SERVICE_INFO' && !showMore) {
      eventClickCouponService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        'informasi kupon servis',
        'lihat selengkapnya'
      );
    } else if (feature === 'PACKAGE_SERVICE_INFO' && !showMore) {
      eventClickPackageService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadcrumbItems,
        userData?.customerNo,
        'informasi paket servis',
        'lihat selengkapnya'
      );
    } else if (feature === FEATURE.LISTING_PROMO && !showMore) {
      eventClickListingPromo({
        dispatch,
        customerNo: userData?.customerNo,
        breadcrumbItems: impressionData?.breadcrumbItems,
        pageName: PAGE_NAME_PROMO.PROMO_LISTING_PAGE,
        pageTitle: impressionData?.pageTitle,
        sectionName: 'informasi promo toyota',
        buttonName: 'lihat selengkapnya',
        newParams: {
          ...(impressionData?.breadcrumbItems?.[2]
            ? { menu_cat_lvl2: impressionData?.breadcrumbItems?.[2].name?.toUpperCase() }
            : {}),
          category: impressionData?.category?.toLowerCase(),
          page_number: impressionData?.page_number,
        },
      });
    } else if (feature === FEATURE.TEST_DRIVE_LISTING_PAGE && !showMore) {
      eventClickTestDriveList(
        impressionData.pageTitle,
        impressionData.category,
        info.title,
        BUTTON_NAME_TEST_DRIVE_LIST.LIHAT_SELENGKAPNYA,
        impressionData.breadcrumbItems[1].name,
        {
          menu_cat_lvl2: impressionData?.menu_cat_lvl2,
        }
      );
    }
    setShowMore(!showMore);
  };

  const isLongContent = formattedDescription?.length > 320;

  if (feature === 'COUPON_SERVICE_DETAIL') {
    useImpressionCouponService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      'detail kupon servis'
    );
  } else if (feature === 'COUPON_SERVICE_LIST') {
    useImpressionCouponServiceList(
      impressionRef,
      impressionData?.pageTitle,
      impressionData?.breadcrumbItems,
      info?.title || '',
      impressionData?.carModels
    );
  } else if (feature === 'COUPON_SERVICE_INFO') {
    useImpressionCouponService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      'informasi kupon servis'
    );
  } else if (feature === 'NCP_PDP') {
    useImpressionNCP(
      impressionRef,
      impressionData.title,
      impressionData.pageTitle,
      impressionData.carModel,
      impressionData.menu
    );
  } else if (feature === 'PACKAGE_SERVICE_INFO') {
    useImpressionPackageService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      'informasi paket servis'
    );
  } else if (feature === 'PACKAGE_SERVICE_LIST') {
    useImpressionPackageServiceList(
      impressionRef,
      impressionData?.pageTitle,
      impressionData?.breadcrumbItems,
      'informasi paket servis',
      impressionData?.carModels
    );
  } else if (feature === 'ACCESSORIES_DESCRIPTION') {
    useImpressionAccessories(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      impressionData.sku,
      impressionData.skuPrice,
      'product description',
      impressionData.carModels
    );
  } else if (feature === 'ACCESSORIES_INFO') {
    useImpressionAccessories(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      impressionData.sku,
      impressionData.skuPrice,
      info?.title || 'aksesoris & spareparts toyota',
      impressionData.carModels
    );
  } else if (feature === 'LISTING_PRODUCT_KNOWLEDGE') {
    useImpressionProductKnowledgeList(
      impressionRef,
      impressionData.pageTitle,
      impressionData.category,
      impressionData.page_number,
      'informasi review'
    );
  } else if (feature === 'NEWS_LIST') {
    useImpressionNewsList(
      impressionRef,
      impressionData.pageTitle,
      impressionData.category,
      impressionData.page_number,
      'informasi berita toyota'
    );
  } else if (feature === 'TEST_DRIVE_DETAIL') {
    useImpressionDetailTestDrive({
      firstRef: impressionRef,
      pageName: 'test drive',
      pageTitle: impressionData.pageTitle,
      breadcrumbItems: impressionData.breadcrumbItems,
      carModel: impressionData?.carModel,
      sectionName: info?.title,
    });
  } else if (feature === FEATURE.LISTING_NEW_CAR) {
    useImpressionNCL(
      dispatch,
      impressionRef,
      impressionData.pageTitle,
      impressionData.category,
      impressionData.carModel,
      'informasi mobil toyota',
      impressionData.breadcrumbItems
    );
  } else if (feature === FEATURE.TEST_DRIVE_LISTING_PAGE) {
    useImpressionTestDriveList(impressionRef, impressionData?.pageTitle, info.title, {
      category: impressionData.category,
      menu_cat_lvl2: impressionData?.menu_cat_lvl2,
    });
  }

  return (
    <section
      className={`my-10 lg:my-20 px-${paddingClassname} ${sectionClassName}`}
      ref={impressionRef}
    >
      <div className={`container xl:px-0 ${containerClassName}`}>
        <h2
          data-testid={titleId}
          className={`text-base font-bold text-reliableBlack uppercase lg:text-2xl ${headingClassName ? headingClassName : 'mb-4 lg:mb-2'}`}
        >
          {info?.title}
        </h2>
        <p
          data-testid={descriptionId}
          className={`prose prose-a:text-hyperLink max-sm:prose-li:text-sm !max-w-full content-description text-xs lg:text-base 
            ${isLongContent && !showMore ? 'line-clamp-4 max-h-[4lh] lg:line-clamp-2 lg:max-h-[2lh]' : 'line-clamp-none max-h-full'} 
            ${contentClassName}`}
          dangerouslySetInnerHTML={{
            __html: formattedDescription,
          }}
          style={{
            WebkitBoxOrient: 'unset',
          }}
        />
        {isLongContent && (
          <label
            htmlFor={idName}
            className={`read-more-trigger text-sm text-hyperLink uppercase mt-5 flex gap-3 items-center cursor-pointer ${labelClassname}`}
          >
            <input
              type="checkbox"
              id={idName}
              className="read-more-state hidden"
              checked={showMore}
              onChange={() => {}}
              onClick={enableSharing ? () => {} : () => toggleShowMore()}
            />
            <span>{showMore ? 'LIHAT LEBIH SEDIKIT' : 'LIHAT SELENGKAPNYA'}</span>
          </label>
        )}
      </div>
    </section>
  );
};

export default InfoSection;
